const isValidInteger = (value: string): boolean =>
  /^\d+$/.test(value) && Number.isSafeInteger(Number(value));

/**
 * Input handlers for a non-negative integer field stored as a string.
 * - `onChange` ignores anything that is not empty or whole digits (live filter).
 * - `onBlur` clamps empty/invalid values to "0" and strips leading zeros, so the
 *   field always settles on a valid whole number.
 */
export const createIntegerInputHandlers = (
  value: string,
  setValue: (value: string) => void,
): {
  onChange: (value: string) => void;
  onBlur: () => void;
} => {
  return {
    onChange: (next: string): void => {
      if (next.length === 0 || isValidInteger(next)) {
        setValue(next);
      }
    },
    onBlur: (): void => {
      setValue(isValidInteger(value) ? String(Number(value)) : "0");
    },
  };
};
